// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__36egX","buttons":"SendReceipts_buttons__1K819","email":"SendReceipts_email__1dZza","bookApptTitle":"SendReceipts_bookApptTitle__2ziUk"};